const O = {
  step: "SUBMIT_BOOKING_NUMBER"
};
function n(e, N) {
  switch (N.type) {
    case "CHANGE_STEP":
      return { ...e, step: N.payload.step };
    case "CANCELLATION_COMPLETED":
      return {
        ...e,
        step: "CANCELLATION_COMPLETED"
      };
    case "SET_BOOKING_INFORMATION":
      return { ...e, booking: N.payload.booking, step: "CONFIRM_CANCELLATION" };
    case "CLEAR_BOOKING_INFORMATION":
      return { ...e, booking: void 0, step: "SUBMIT_BOOKING_NUMBER" };
    default:
      return { ...e };
  }
}
export {
  O as InitialTrailerRentalCancellationState,
  n as TrailerRentalCancellationReducer
};
